import type {GeoJSONSourceRaw} from 'mapbox-gl';

export default function combineLineGeometry(
    sourceFeatures: mapboxgl.MapboxGeoJSONFeature[]
): GeoJSONSourceRaw {
    const coordinates = sourceFeatures
        .map((f) => {
            if (f.geometry.type === 'LineString') {
                return [f.geometry.coordinates];
            } else if (f.geometry.type === 'MultiLineString') {
                return f.geometry.coordinates;
            } else {
                return [];
            }
        })
        .reduce((acc, c) => {
            return [...acc, ...c];
        }, []);
    return {
        type: 'geojson',
        data: {
            type: 'Feature',
            geometry: {
                type: 'MultiLineString',
                coordinates,
            },
            properties: sourceFeatures?.[0]?.properties,
        },
    };
}
